/* eslint-disable react/jsx-props-no-spreading */
import {
  useRef, useEffect, useState,
} from 'react';
import ReactSelect, {
  // OptionTypeBase,
  Props as SelectProps,
  PropsValue,
} from 'react-select';
import { useField } from '@unform/core';

interface OptionTypeBase {
  value: string;
  label: string;
}

interface Props extends SelectProps<OptionTypeBase> {
  name: string;
  optionDefault: OptionTypeBase | OptionTypeBase[] | undefined;
}

const SelectUnform = ({ name, optionDefault, ...rest }: Props) => {
  const selectRef = useRef(null);

  const [valor, setValor] = useState<PropsValue<OptionTypeBase> | undefined>(optionDefault);

  const handleChange = (option: PropsValue<OptionTypeBase>) => (
    setValor(option)
  );

  const {
    fieldName, registerField, error,
  } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref) => {
        if (ref.props.isMulti) {
          if (!ref.state.selectValue) {
            return [];
          }

          return ref.state.selectValue.map((option: OptionTypeBase) => option.value);
        }

        if (!ref.props.value) {
          return '';
        }

        return ref.props.value.value;
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  useEffect(() => {
    setValor(optionDefault);
  }, [optionDefault]);

  return (
    <>
      <ReactSelect
        value={valor}
        ref={selectRef}
        classNamePrefix="react-select"
        onChange={handleChange}
        {...rest}
      />
      <span className="text-danger">{error}</span>
    </>
  );
};

export default SelectUnform;
